export default {
  namespaced: true,
  state: {
    id: '',
    json: {},
  },
  getters: {
    last_whatsapp_id(state) {
      return state.id
    },
    last_whatsapp_json(state) {
      return state.json
    },
  },
  mutations: {
    UPDATE_WHATSAPP_ID(state, val) {
      state.id = val
    },
    UPDATE_WHATSAPP_JSON(state, val) {
      state.json = val
    }
  },
  actions: {},
}
